import { Alert, Spin } from "antd";
import { ReactElement, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { useSession } from "@lib/authentication/SessionHooks";
import s from "./LoginPage.module.scss";

export function CallbackPage(): ReactElement {
  const { t } = useTranslation();
  const auth = useAuth();
  const { initialized, session } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!initialized) return;

    if (session.authenticated) {
      // Il dispatcher decide: realm platform → /console, tenant → /app/dashboard.
      void navigate("/", { replace: true });
      return;
    }

    // Errore OIDC (es. access_denied / stato non valido): niente vicolo cieco —
    // torna alla login page (identificativo precompilato) così l'utente riprova.
    if (auth?.error) {
      void navigate("/login", { replace: true });
      return;
    }

    if (!auth?.isLoading && !auth?.activeNavigator && !auth?.isAuthenticated)
      void navigate("/login", { replace: true });
  }, [
    initialized,
    session.authenticated,
    auth?.isAuthenticated,
    auth?.isLoading,
    auth?.activeNavigator,
    auth?.error,
    navigate,
  ]);

  return (
    <div className={s.container}>
      {auth?.error ? (
        <Alert
          type="error"
          showIcon
          title={t("loginpage.errors.internalError")}
          description={auth.error.message}
        />
      ) : (
        <Spin size="large" />
      )}
    </div>
  );
}
